
































































































































import Vue from 'vue'
import Multiselect from 'vue-multiselect'

import Component from 'vue-class-component'
import RespondecoTopBar from '../../../main/respondeco-top-bar.vue'
import { MetaService } from '@/shared/services/meta-service'
import { FETCH_OFFER } from '../store/types'
import OfferSidebar from '@/business/offers/components/offer-sidebar.vue'
import { OfferResponse } from '@/api/generated'
import { OffersModule } from '@/business/offers/store/offers-module'
import { Injector } from '@/config/dependency-injection'
import { VueRouter } from 'vue-router/types/router'
import { RouterToken } from '@/config/injection-tokens'
import { LoaderHelper } from '@/shared/services/loader-helper'
import { imageUrl } from '@/shared/utils/images'
import RespondecoCategories from '@/shared/components/respondeco-categories.vue'
import { HttpResponse } from '@/commons/types/http-response'
import { NotificationService } from '@/shared/services/notification-service'
import HttpError from '@/shared/components/http-error.vue'
import RespondecoBackgroundImage from '@/shared/components/respondeco-background-image.vue'
import RespondecoLoadingIndicator from '@/shared/components/respondeco-loading-indicator.vue'
import RespondecoEditItemBar from '@/main/respondeco-edit-item-bar.vue'
import { EmptyOfferViewModel } from '@/business/offers/models/offer-view-model'
import RespondecoContactAuthor from '@/shared/components/respondeco-contact-author.vue'
import RespondecoAuthorSection from '@/shared/components/respondeco-author-section.vue'
import RespondecoHeaderImage from '@/shared/components/respondeco-header-image.vue'
import RespondecoCarousel from '@/shared/components/respondeco-carousel.vue'
import { Hooks } from '@/shared/interfaces/hooks'
import { Route } from '@/shared/interfaces/route'
import RespondecoEditorLiveView from '@/shared/components/respondeco-editor-live-view.vue'
import RespondecoPost from '@/business/post/components/post/post.vue'
import RespondecoEditablePost from '@/business/post/components/editable-post/editable-post.vue'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import RespondecoPosts from '@/business/post/components/posts.vue'
import RespondecoPortfolioItem from '@/shared/components/respondeco-portfolio-item.vue'
import RespondecoResponsiveImage from '@/shared/components/respondeco-responsive-image.vue'
import OfferPartners from '@/business/offers/components/offer-partners.vue'
import OfferPosts from '@/business/offers/components/offer-posts.vue'
import { OfferLite } from '@/business/offers/models/offer-lite'
import { format } from 'date-fns'
import { de } from 'date-fns/locale'
import { environmentConfiguration } from '@/config/environments'
import { activeUserIsOwner } from '@/shared/utils/user'

@Component({
  components: {
    OfferPosts,
    OfferPartners,
    RespondecoResponsiveImage,
    RespondecoPortfolioItem,
    RespondecoPosts,
    UnifyButton,
    RespondecoEditablePost,
    RespondecoPost,
    RespondecoEditorLiveView,
    RespondecoCarousel,
    RespondecoContactAuthor,
    RespondecoAuthorSection,
    RespondecoHeaderImage,
    RespondecoEditItemBar,
    RespondecoLoadingIndicator,
    RespondecoBackgroundImage,
    HttpError,
    RespondecoCategories,
    OfferSidebar,
    Multiselect,
    RespondecoTopBar,
  },
  data() {
    return {
      error: undefined,
    }
  },
})
export default class Offer extends Vue implements Hooks {
  public branding = environmentConfiguration().branding
  public error?: HttpResponse<any>
  // Offer ID (set in created() component hook)
  public id!: number
  public imageUrl = imageUrl

  private loaderHelper = Injector.get(LoaderHelper)
  private metaService: MetaService = Injector.get(MetaService)
  private notificationService = Injector.get(NotificationService)
  private offersModule: OffersModule = Injector.get(OffersModule)
  private router: VueRouter = Injector.get(RouterToken)

  // Currently disabled as emptying the state will result in an error if the user is not allowed to
  // perform the navigation.
  //
  // public beforeRouteLeave(to: string, from: string, next: () => {}) {
  //   this.offersModule[CLEAR_OFFER]()
  //
  //   next()
  // }

  get headerImages(): string[] {
    return (
      this.offer.resources
        .find(resource => resource.name === 'header')
        ?.resources.map(resource => resource.location) ?? []
    )
  }

  get loading() {
    return this.loaderHelper.isLoading(FETCH_OFFER)
  }

  get offer(): OfferResponse {
    return this.viewModel.offer || EmptyOfferViewModel.offer
  }

  get organisation() {
    return this.offer.organisation
  }

  get showLinkToReport(): boolean {
    let showLink = false

    if (this.offer) {
      showLink =
        (this.offer.hasReport && this.offer.reportIsPublished) ||
        (this.offer.hasReport && activeUserIsOwner(this.offer.organisation.id))
    }

    return showLink
  }

  get viewModel() {
    return this.offersModule.offer
  }

  public beforeRouteUpdate(to: Route) {
    if (to.name === this.router.currentRoute.name) {
      this.id = Number(to.params.id)

      this.fetchData()
    }
  }

  public created() {
    this.id = parseInt(this.router.currentRoute.params.id, 10)

    if (this.id !== -1) {
      this.fetchData()
    }
  }

  public formatDate(item: OfferLite): string {
    let date = ''

    if (item.dateFrom && item.dateUntil) {
      date = format(item.dateFrom, 'dd. MMMM yyyy', { locale: de }) + ' '
      date += format(item.dateFrom, 'HH:mm') + ' - '
      date += format(item.dateUntil, 'HH:mm') + ' Uhr'
    }

    return date
  }

  private fetchData() {
    this.offersModule
      .fetchOffer(this.id)
      .then(vm => {
        this.metaService.updateDocumentTitle('offer', {
          name: vm.offer.name,
          organisation: vm.offer.organisation.name,
        })

        this.metaService.updateSeo({
          creator: vm.offer.organisation.name,
          description: vm.offer.shortDescription,
          image: this.getLogo(),
        })
      })
      .catch(error => {
        this.error = error
        this.notificationService.error(error)
      })
  }

  private getLogo(): string | undefined {
    let logo: string | undefined

    const resource =
      this.offer.resources.find(resource => resource.name === 'logo')?.resources[0]?.location ??
      this.offer.organisation.image

    if (resource) {
      logo = imageUrl(resource, 1200)
    }

    return logo
  }
}
